var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_auth_propergate_platform_dev_ppgt_app_remoteEntry_mjs_8566c5f2__;